module.exports = __webpack_public_path__ + "img/periodicos.bd38eb80.png";